// TODO: remove when v1 strips are fully phased out // SIPP-642
import { ArrowForward } from '@mui/icons-material'
import {
  AppBar,
  Box,
  Button,
  Container,
  Grid,
  Typography,
  useTheme,
} from '@mui/material'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { AppDispatch } from '../../store'
import { UserActions, UserSelector } from '../../store/User'

// TODO: remove when v1 strips are fully phased out // SIPP-642
export const StripVersionDetection = () => {
  const theme = useTheme()
  const dispatch = useDispatch<AppDispatch>()
  const navigate = useNavigate()
  const user = useSelector(UserSelector.user)
  const [selected, setSelected] = useState<'v1' | 'v2' | null>(null)

  const submit = async () => {
    if (!selected || !user?._id) return

    const result = await dispatch(
      UserActions.updateUserStripVersionAsync({ id: user._id, stripVersion: selected }),
    )

    if (UserActions.updateUserStripVersionAsync.fulfilled.match(result)) {
      navigate('/test-strip/update')
    }
  }

  return (
    <Container
      maxWidth="md"
      sx={{
        justifyContent: 'flex-start',
        alignContent: 'center',
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
        paddingBottom: '60px',
      }}
    >
      <Typography variant="h2" textAlign="center">
        About your test strip
      </Typography>
      <Typography variant="body1" textAlign="center" sx={{ mt: 1 }}>
        Does your test strip bag have a brightly colored sticker on it?
      </Typography>
      <Typography variant="body-small" textAlign="center" sx={{ mb: 3 }}>
        The newest test strips come in a bag with a bright colored sticker on it.
      </Typography>

      <Grid container justifyContent="center" spacing={2} sx={{ mt: 2 }}>
        <StripVersionButton label="Yes" selected={selected === 'v2'} onClick={() => setSelected('v2')} />
        <StripVersionButton label="No" selected={selected === 'v1'} onClick={() => setSelected('v1')} />
      </Grid>

      <AppBar
        position="fixed"
        color="default"
        sx={{ top: 'auto', bottom: 0, height: '60px', justifyContent: 'center' }}
      >
        <Container maxWidth="sm" sx={{ display: 'flex', justifyContent: 'center', gap: 1 }}>
          <Button
            variant="contained"
            size="large"
            sx={{ flexGrow: 1 }}
            endIcon={<ArrowForward />}
            onClick={submit}
            disabled={!selected}
          >
            Next
          </Button>
        </Container>
      </AppBar>
    </Container>
  )
}

const StripVersionButton = ({
  label,
  onClick,
  selected,
}: {
  label: string
  onClick: () => void
  selected: boolean
}) => {
  const theme = useTheme()

  return (
    <Box
      sx={{
        p: 3,
        minWidth: '140px',
        background: selected ? theme.palette.blue[50] : theme.palette.grey[100],
        borderRadius: theme.shape.borderRadius,
        borderColor: selected ? theme.palette.blue[600] : theme.palette.grey[100],
        borderStyle: 'solid',
        borderWidth: selected ? '1px' : '0px',
        cursor: 'pointer',
        textAlign: 'center',
      }}
      onClick={onClick}
    >
      <Typography variant="body1">{label}</Typography>
    </Box>
  )
}
